export default __webpack_public_path__ + "static/media/slide-three.8d937f20.png";